
document.addEventListener('DOMContentLoaded', function () {
    const backToTopBtn = document.querySelector('.back-to-top');
    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', function () {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }

    window.addEventListener('scroll', function () {
        if (backToTopBtn) {
            if (window.pageYOffset > 50) {
                backToTopBtn.style.display = 'inline';
            } else {
                backToTopBtn.style.display = 'none';
            }
        }
    });
});